import React, { useMemo } from 'react';
import { useImmer } from 'use-immer';
import { Model, Folder, Image, UndefinedAsset } from '../Asset';
import { OfficialAssetContentBanner } from '../OfficialAssetList/OfficialAssetnContentBanner';
import { AssetItem, AssetType } from '@/type';

export interface ContentQueryType {
  type: AssetType | 'all';
  keyword: string;
}

export function UserAssetContent(props: {
  data: AssetItem[];
  workingFolder: { id: string; name: string } | null;
  onFolderSelect: (folder: { id: string; name: string }) => void;
  onSelected: (item: AssetItem) => void;
}) {
  const { workingFolder, data, onSelected, onFolderSelect } = props;
  const [contentQuery, setContentQuery] = useImmer<string>('');

  const orderedData = useMemo(() => {
    const sortedData = data.sort((a, b) => {
      if (a.type !== b.type) {
        return a.type > b.type ? 1 : -1;
      }
      if (a.name !== b.name) {
        return a.name > b.name ? 1 : -1;
      }
      return 0;
    });

    return sortedData.filter((a) => a.name.includes(contentQuery) && a.type !== 'folder');
  }, [contentQuery, data]);

  const getAssetComp = (item: AssetItem) => {
    switch (item.type) {
      case 'model': {
        return (
          <Model
            key={item.id}
            data={item as AssetItem<'model'>}
            onSelected={(item) => {
              onSelected(item);
            }}
          />
        );
      }
      case 'folder': {
        return (
          <Folder
            key={item.id}
            data={item as AssetItem<'folder'>}
            onDoubleClick={(item: { id: string; name: string }) => {
              onFolderSelect(item);
            }}
          />
        );
      }
      case 'image': {
        return (
          <Image
            key={item.id}
            data={item as AssetItem<'image'>}
            onSelected={(item) => {
              onSelected(item);
            }}
          />
        );
      }
      case 'material':
      default: {
        return <UndefinedAsset key={item.id} data={item} />;
      }
    }
  };

  return (
    <>
      <OfficialAssetContentBanner workingFolder={workingFolder} setContentQuery={setContentQuery} />
      <div className='px-6 pt-4 grid grid-cols-[repeat(auto-fill,minmax(102px,1fr))] grid-rows-[repeat(auto-fill,1fr)] gap-x-3 gap-y-4 overflow-y-auto no-scroll-container'>
        {orderedData.map((item) => {
          return (
            <div key={item.id} className='flex items-center justify-center'>
              {getAssetComp(item)}
            </div>
          );
        })}
      </div>
    </>
  );
}
